import React, { useEffect, useState } from 'react'
import {
  Button,
  Grid,
  Typography,
} from '@material-ui/core'

import { GenericCard } from '../ModelCard'
import {
  FoundEvent,
  FoundHandler,
  FoundHandlerCallback,
  Mode,
} from 'src/scanRouter/handlers'

import { MeasurementCard } from './MeasurementCard'
import { FoundItemDisplay } from './FoundItemDisplay'
import { SkuSelectionCard } from './SkuSelectionCard'

interface FoundDisplayProps {
  handler: FoundHandler
}

export const FoundDisplay = (props: FoundDisplayProps) => {
  const { handler } = props
  const [saving, setSaving] = useState(false)
  const [mode, setMode] = useState<Mode>(Mode.Scan)
  const [error] = useState(false)
  const [, refresh] = useState({})

  useEffect(() => {
    const cb: FoundHandlerCallback = (data: any) => {
      if (data.event === FoundEvent.Save) {
        setSaving(data.saving)
      } else {
        refresh({})
      }
    }
    handler.registerCb(cb)
    return () => handler.removeCb(cb)
  }, [handler, refresh, setSaving])
  return (
    <Grid container justify="center" spacing={2}>
      <Grid item>
        <GenericCard item={handler.source} />
      </Grid>
      <Grid container item justify="center" spacing={6}>
        <Grid item>
          <Button
            color="primary"
            variant={mode === Mode.Scan ? 'contained' : 'outlined'}
            onClick={() => {
              handler.setMode(Mode.Scan)
              setMode(handler.mode)
            }}
          >
            Scan
          </Button>
        </Grid>
        <Grid item>
          <Button
            color="primary"
            variant={mode === Mode.Unscan ? 'contained' : 'outlined'}
            onClick={() => {
              handler.setMode(Mode.Unscan)
              setMode(handler.mode)
            }}
          >
            UnScan
          </Button>
        </Grid>
      </Grid>
      <>
        {handler.toMeasure ? (
          <MeasurementCard
            product={handler.toMeasure.product.object}
            unitOfMeasure={handler.toMeasure.sku?.object.unitOfMeasureDisplay}
            measure={handler.provideMeasure(handler.toMeasure)}
          />
        ) : (
          <>
            {handler.toResolve ? (
              <SkuSelectionCard
                skus={handler.toResolve.skus}
                select={(sku) => {
                  handler.setSku(sku)
                }}
              />
            ) : (
              <>
                {handler.inventory.items.map((item) => (
                  <FoundItemDisplay key={item.key} handler={handler} item={item} />
                ))}
              </>
            )}
          </>
        )}
      </>
      {!!error && (
        <>
          <Grid item>
            <Typography color="error">Failed move: {error}</Typography>
          </Grid>
          <Grid item>
            <Typography>Scan to restart scan sequence</Typography>
          </Grid>
        </>
      )}
      {!!handler.inventory.items.length && (
        <Grid item>
          <Button color="primary" disabled={false} onClick={handler.save}>
            Cancel
          </Button>
          <Button color="primary" variant="contained" disabled={false} onClick={handler.save}>
            {saving ? 'Saving...' : 'Save'}
          </Button>
        </Grid>
      )}
    </Grid>
  )
}
